import { ExportId, ExportSectionDefinition } from '../types'

export const EXPORT_SECTIONS: ExportSectionDefinition[] = [
  {
    title: 'Prescribers & Admins',
    exports: [
      {
        id: ExportId.ACTIVE_PRESCRIBERS,
        name: 'Active Prescribers',
        description: 'All currently active prescribers with registration details',
        iconVariant: 'blue',
      },
      {
        id: ExportId.ACTIVE_ADMINS,
        name: 'Active Admins',
        description: 'All currently active admin users and their access levels',
        iconVariant: 'green',
      },
    ],
  },
  {
    title: 'Prescriptions — Monthly Reports',
    exports: [
      {
        id: ExportId.PRESCRIPTIONS_BY_PRESCRIBER,
        name: 'Prescriptions by Prescriber',
        description: 'Monthly prescription count grouped by each prescriber',
        iconVariant: 'purple',
        requiresMonth: true,
      },
      {
        id: ExportId.PRESCRIPTIONS,
        name: 'Prescriptions',
        description: 'All prescriptions issued in the selected month',
        iconVariant: 'purple',
        requiresMonth: true,
      },
    ],
  },
  {
    title: 'Prescribed Items — Monthly Reports',
    exports: [
      {
        id: ExportId.PRESCRIBED_ITEMS,
        name: 'Prescribed Items',
        description: 'Line-level items for all prescriptions in the selected month',
        iconVariant: 'amber',
        requiresMonth: true,
      },
      {
        id: ExportId.LITE_PRESCRIBED_ITEMS,
        name: 'Lite Prescribed Items',
        description: 'Lite scheme prescribed items for the selected month',
        iconVariant: 'amber',
        requiresMonth: true,
      },
    ],
  },
]
